import $ from 'jquery';
import wNumb from 'wnumb';
import noUiSlider from 'nouislider';
import mergeTooltips from './nouislider-merge-tooltips.js';
import 'nouislider/dist/nouislider.css';

import LocationField from './location-field.js';

class PropertiesCatalog {
    constructor(el) {
        this.$el = $(el);

        this.rangeSliders = [];

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$propertiesList = this.$el.find('.properties-catalog__results');
        this.$propertiesResults = this.$el.find('.properties-catalog__results .property-item');
        this.$filtersForm = this.$el.find('.properties-catalog__filters');
        this.$rangeSliders = this.$el.find('.price-range-slider');
        this.$locationField = this.$el.find('.location-field');
        this.$offerTypeFilter = this.$filtersForm.find('input[type="checkbox"][name="offer_type"]');
        this.$mobileFilters = $('.filter-mobile');
        this.$closeMobileFilters = $('.close-filters');
        this.$optionsCheckLists = [...document.querySelectorAll('.dropdown-check-list')];

        this.priceRanges = {
            rent: {
                $container: this.$filtersForm.find('.form-container__price-range--location'),
                $el: this.$filtersForm.find('.form-container__price-range--location .price-range-slider'),
                $min: this.$filtersForm.find('input[type="hidden"][name="min_rent_price"]'),
                $max: this.$filtersForm.find('input[type="hidden"][name="max_rent_price"]')
            },
            sale: {
                $container: this.$filtersForm.find('.form-container__price-range--vente'),
                $el: this.$filtersForm.find('.form-container__price-range--vente .price-range-slider'),
                $min: this.$filtersForm.find('input[type="hidden"][name="min_sale_price"]'),
                $max: this.$filtersForm.find('input[type="hidden"][name="max_sale_price"]')
            }
        };
        this.floorAreaRanges = {
            rent: {
                $container: this.$filtersForm.find('.form-container__size-range--location'),
                $el: this.$filtersForm.find('.form-container__size-range--location .price-range-slider'),
                $min: this.$filtersForm.find('input[type="hidden"][name="min_rent_floor_area"]'),
                $max: this.$filtersForm.find('input[type="hidden"][name="max_rent_floor_area"]')
            },
            sale: {
                $container: this.$filtersForm.find('.form-container__size-range--vente'),
                $el: this.$filtersForm.find('.form-container__size-range--vente .price-range-slider'),
                $min: this.$filtersForm.find('input[type="hidden"][name="min_sale_floor_area"]'),
                $max: this.$filtersForm.find('input[type="hidden"][name="max_sale_floor_area"]')
            }
        };
        this.locationField = null;

        if(this.$propertiesList.length) {
            if(this.$locationField.length) {
                this.locationField = new LocationField(this.$locationField[0]);
            }

            if(this.$rangeSliders.length) {
                this._createRangeSlider();
            }
            
            if(this.$filtersForm.length) {
                this._bindEvents();
            }
        }
    }

    _bindEvents() {
        this.onSubmitFn = this._onSubmit.bind(this);
        this.onResetFn = this._onReset.bind(this);
        this.onOfferTypeChangeFn = this._onOfferTypeChange.bind(this);
        this.onPropertyMouseEnterFn = this._onPropertyMouseEnter.bind(this);
        this.onPropertyMouseLeaveFn = this._onPropertyMouseLeave.bind(this);
        this.onMobileFiltersOpeningFn = this._onMobileFiltersOpening.bind(this);
        this.onMobileFiltersClosingFn = this._onMobileFiltersClosing.bind(this);
        this.onOptionsChecklistClickFn = this._onOptionsChecklistClick.bind(this);

        this.$filtersForm.on('submit', this.onSubmitFn);
        this.$filtersForm.on('reset', this.onResetFn);
        this.$offerTypeFilter.on('change', this.onOfferTypeChangeFn);
        this.$propertiesResults.on('mouseenter', this.onPropertyMouseEnterFn);
        this.$propertiesResults.on('mouseleave', this.onPropertyMouseLeaveFn);

        // Système de filtres pour la version responsive des offres de biens
        this.$mobileFilters.on('click', this.onMobileFiltersOpeningFn);
        this.$closeMobileFilters.on('click', this.onMobileFiltersClosingFn);

        // Ouverture/fermeture des listes à choix multiples (checkbox)
        this.$optionsCheckLists.forEach((element) => {
            const anchor = element.querySelector('.anchor');
            console.log(anchor);
            if(anchor) {
                anchor.addEventListener('click', this.onOptionsChecklistClickFn);
            }
        });
    }

    _onPropertyMouseEnter(e) {
        const {currentTarget} = e;
        
        console.log('_onPropertyMouseEnter', e);
        if(currentTarget.hasAttribute('data-id')) {
            const propertyId = currentTarget.getAttribute('data-id');
            console.log('id', propertyId);

            document.dispatchEvent(new CustomEvent('properties-map:focusMarker', {detail: {id: propertyId}}));
        }
    }

    _onPropertyMouseLeave(e) {
        const {currentTarget} = e;
        
        console.log('_onPropertyMouseLeave', e);
        if(currentTarget.hasAttribute('data-id')) {
            const propertyId = currentTarget.getAttribute('data-id');
            console.log('id', propertyId);

            document.dispatchEvent(new CustomEvent('properties-map:defocusMarker', {detail: {id: propertyId}}));
        }
    }

    _onMobileFiltersOpening(event) {
        event.preventDefault;
        
        this.$filtersForm.toggleClass('filters--openned');
        this.$mobileFilters.toggleClass('filters--openned');
    }

    _onMobileFiltersClosing(event) {
        event.preventDefault;

        this.$filtersForm.toggleClass('filters--openned');
        this.$mobileFilters.toggleClass('filters--openned');
    }

    _createRangeSlider() {
        ['rent', 'sale'].forEach((type) => {
            const rangeSliders = [this.priceRanges[type], this.floorAreaRanges[type]];

            rangeSliders.forEach((range) => {
                const $rangeSlider = range.$el;
                const min = parseInt($rangeSlider.attr('data-min'), 10);
                const max = parseInt($rangeSlider.attr('data-max'), 10);
                const start = parseInt($rangeSlider.attr('data-value-min'), 10);
                const end = parseInt($rangeSlider.attr('data-value-max'), 10);
                const step = parseInt($rangeSlider.attr('data-step'), 10);
                const name = $rangeSlider.attr('data-name');
                const $minInput = $rangeSlider.find(`input[type="hidden"][name="min_${name}"]`);
                const $maxInput = $rangeSlider.find(`input[type="hidden"][name="max_${name}"]`);
                noUiSlider.cssClasses.target += ' range-slider';

                const slider = noUiSlider.create($rangeSlider[0], {
                    start: [start, end],
                    tooltips: true,
                    connect: true,
                    step: step,
                    range: {
                        min: min,
                        max: max
                    },
                    format: wNumb({
                        suffix: name.indexOf('price') !== -1 ? ' €' : ' m2',
                        decimals: 0,
                        thousand: ' '
                    })
                });
                slider.on('set', function(values, handle, unencoded, tap, positions, noUiSlider) {
                    $minInput.val(unencoded[0]);
                    $maxInput.val(unencoded[1]);
                });
                mergeTooltips($rangeSlider[0], 40, ' - ');

                this.rangeSliders.push(slider);
            });
        });
    }

    _closeAllChecklists(listElement, willBeOpened) {
        this.$optionsCheckLists.forEach((element) => {
            if ((!willBeOpened && element === listElement) || (element !== listElement && element.classList.contains('visible'))) {
                element.classList.remove('visible');
            }
        });
    }

    _onOptionsChecklistClick(event) {
        const target = event.target.parentNode;

        if (target.classList.contains('visible')) {
            target.classList.remove('visible');
        }
        else {
            target.classList.add('visible');
        }

        this._closeAllChecklists(target, target.classList.contains('visible'));
    }

    _onOfferTypeChange(e) {
        const offerType = this.$offerTypeFilter[0].checked ? 'rent' : 'sale';
        
        if(offerType === 'sale') {
            this.priceRanges.rent.$container.hide();
            this.priceRanges.sale.$container.show();
            this.floorAreaRanges.rent.$container.hide();        
            this.floorAreaRanges.sale.$container.show();
        }
        else if(offerType === 'rent') {
            this.priceRanges.rent.$container.show();
            this.priceRanges.sale.$container.hide();
            this.floorAreaRanges.rent.$container.show();
            this.floorAreaRanges.sale.$container.hide();
        }
    }

    _onSubmit(e) {
        e.preventDefault();
        
        if(this.locationField.isValid()) {
            this.$filtersForm.find('input[type="hidden"][name="pag"]').val('0');
            this.$filtersForm[0].submit();
        }
    }

    _onReset(e) {
        e.preventDefault();

        this.rangeSliders.forEach((rangeSlider) => {
            rangeSlider.set([rangeSlider.options.range.min, rangeSlider.options.range.max]);
        });
        this.$filtersForm.find('input[type="checkbox"]').prop('checked', false);
        this.$filtersForm.find('input[type="text"], textarea').val('');
        this.$filtersForm.find('select').each((index, select) => select.selectedIndex = 0);
        this.$filtersForm.find('input[type="hidden"]').val('');
        this.$filtersForm.find('input[type="hidden"][name="pag"]').val('0');
    }
}

export default PropertiesCatalog;

new PropertiesCatalog(document.querySelector('.properties-catalog'));